// FieldMapEditorHeader.jsx
import React from "react";
import Button from "../common/Button";
import styles from "./FieldMapEditorHeader.module.css";

export default function FieldMapEditorHeader({
  title,
  setTitle,
  onSave,
  onOpenDrafts,
  onOpenMap,
  hasActiveDraft,
  hasUnsavedChanges,
  drafts,
  onCreateNew,
  maxDrafts = 10,
}) {
  return (
    <div className={styles.header}>
      <div className={styles.brand}>
        <h1>FIELDMAP</h1>
        <span className={styles.subtitle}>
          Campo Funcional para Formulação Clínica Baseada em Processos
        </span>
      </div>

      <div className={styles.context}>
        {hasActiveDraft ? (
          <div className={styles.titleRow}>
            {/* <strong className={styles.title}>
              {title || "FIELDMAP sem título"}
            </strong> */}
            <input
              type="text"
              placeholder={title || "FIELDMAP sem título"}
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />

            {hasUnsavedChanges ? (
              <span className={styles.unsaved} title="Alterações não salvas">
                ● Não salvo
              </span>
            ) : (
              <span
                className={styles.saved}
                title="Todas as alterações foram salvas"
              >
                ✓ Salvo
              </span>
            )}
          </div>
        ) : (
          <div>
            <span className={styles.empty}>Nenhum FIELDMAP ativo </span>
            <Button
              variant="primary"
              onClick={onCreateNew}
              disabled={drafts.length >= maxDrafts}
            >
              + Novo
            </Button>
          </div>
        )}
      </div>

      <div className={styles.actions}>
        <Button
          variant="primary"
          onClick={onSave}
          disabled={!hasActiveDraft || !hasUnsavedChanges}
        >
          Salvar
        </Button>

        <Button variant="secondary" onClick={onOpenDrafts}>
          Meus FIELDMAPs
        </Button>

        {hasActiveDraft && (
          <Button variant="secondary" onClick={onOpenMap}>
            Visualizar campo
          </Button>
        )}
      </div>
    </div>
  );
}
